import type { AxiosRequestConfigExtended } from '@vision/ui/interfaces';
import type { PlannerTaskWatcherCreateArgs, PlannerTaskWatcherDeleteArgs } from './task-watchers.api.types';
import { createHttpExtraOptions } from '@vision/ui/utils';

export const buildCreateWatcherRequest = ({
  plannerId,
  accountId,
  dashboardId,
  taskId,
  body,
}: PlannerTaskWatcherCreateArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/watchers?account_id=${accountId}&dashboard_id=${dashboardId}&task_id=${taskId}`,
  method: 'POST',
  data: body,
  headers: {
    'Content-Type': 'application/json',
  },
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.createWatcher.{{status}}',
      autoHandleSuccess: false,
    },
  }),
});

export const buildDeleteWatcherRequest = ({
  plannerId,
  accountId,
  dashboardId,
  taskId,
  watcherId,
}: PlannerTaskWatcherDeleteArgs): AxiosRequestConfigExtended => ({
  url: `/v2/planners/${plannerId}/watchers/${watcherId}/delete`,
  method: 'POST',
  params: {
    account_id: accountId,
    dashboard_id: dashboardId,
    task_id: taskId,
  },
  extraOptions: createHttpExtraOptions({
    notification: {
      translationMessageKey: 'http.message.planner.deleteWatcher.{{status}}',
      autoHandleSuccess: false,
    },
  }),
});
